/* ============================================================
   Carsync Vision — PDP behavior
   - Accordions (hero + FAQ)
   - Media gallery (thumbnail switching)
   - Variant selection (syncs every add-to-cart form on the page)
   - "Buy now" -> add to cart, then redirect to checkout
   - Video play overlays (hosted + external)
   - Sticky mobile add-to-cart bar reveal
   All handlers are idempotent and re-run on Shopify section load
   so they keep working inside the theme editor.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Accordions ---------- */
  function initAccordions(root) {
    (root || document).querySelectorAll('.cv-acc-item').forEach(function (item) {
      var head = item.querySelector('.cv-acc-head');
      var body = item.querySelector('.cv-acc-body');
      if (!head || !body || head.dataset.cvBound) return;
      head.dataset.cvBound = '1';
      head.setAttribute('aria-expanded', item.classList.contains('cv-open') ? 'true' : 'false');
      head.addEventListener('click', function () {
        var open = item.classList.toggle('cv-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        body.style.maxHeight = open ? body.scrollHeight + 24 + 'px' : null;
      });
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    (root || document).querySelectorAll('.cv-gallery').forEach(function (gallery) {
      if (gallery.dataset.cvBound) return;
      gallery.dataset.cvBound = '1';
      var thumbs = gallery.querySelectorAll('.cv-thumb');
      var slides = gallery.querySelectorAll('.cv-gmain-slide');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = thumb.getAttribute('data-cv-index');
          thumbs.forEach(function (t) { t.classList.remove('cv-active'); });
          slides.forEach(function (s) {
            s.classList.toggle('cv-active', s.getAttribute('data-cv-index') === idx);
          });
          thumb.classList.add('cv-active');
        });
      });
    });
  }

  /* ---------- Variants (sync all forms on the page) ---------- */
  function initVariants(root) {
    var dataEl = (root || document).querySelector('[data-cv-variants]');
    var picker = (root || document).querySelector('.cv-variants[data-cv-variant-picker]');
    if (!dataEl || !picker || picker.dataset.cvBound) return;
    picker.dataset.cvBound = '1';

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var moneyFormat = dataEl.getAttribute('data-money-format') || '{{amount}}';

    function formatMoney(cents) {
      var noDecimals = /no_decimals/.test(moneyFormat);
      var amount = (cents / 100).toLocaleString('ro-RO', {
        minimumFractionDigits: noDecimals ? 0 : 2,
        maximumFractionDigits: noDecimals ? 0 : 2,
      });
      if (/\{\{[^}]*\}\}/.test(moneyFormat)) {
        return moneyFormat.replace(/\{\{[^}]*\}\}/, amount);
      }
      return amount + ' lei';
    }

    function selectedOptions() {
      var opts = [];
      picker.querySelectorAll('.cv-variant-group').forEach(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function update() {
      var variant = findVariant(selectedOptions());
      if (!variant) return;

      /* Update every add-to-cart form / buy-now button on the page */
      document.querySelectorAll('[data-cv-variant-id]').forEach(function (input) {
        if (input.tagName === 'INPUT') { input.value = variant.id; }
        else { input.setAttribute('data-cv-variant-id', variant.id); }
      });
      document.querySelectorAll('input[name="id"][data-cv-form-id]').forEach(function (input) {
        input.value = variant.id;
      });

      /* Availability */
      document.querySelectorAll('[data-cv-atc]').forEach(function (btn) {
        if (variant.available) {
          btn.removeAttribute('disabled');
          btn.classList.remove('cv-btn--sold-out');
          if (btn.dataset.cvLabel) btn.textContent = btn.dataset.cvLabel;
        } else {
          btn.setAttribute('disabled', 'disabled');
          btn.classList.add('cv-btn--sold-out');
          if (!btn.dataset.cvLabel) btn.dataset.cvLabel = btn.textContent;
          var soldout = btn.getAttribute('data-cv-soldout-label');
          if (soldout) btn.textContent = soldout;
        }
      });

      /* Price displays */
      document.querySelectorAll('[data-cv-price]').forEach(function (el) {
        el.textContent = formatMoney(variant.price);
      });
      document.querySelectorAll('[data-cv-compare]').forEach(function (el) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          el.textContent = formatMoney(variant.compare_at_price);
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });

      /* URL */
      if (variant.id && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    picker.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', update);
    });
    update();
  }

  /* ---------- Buy now (add to cart -> checkout) ---------- */
  function initBuyNow(root) {
    (root || document).querySelectorAll('[data-cv-buy-now]').forEach(function (btn) {
      if (btn.dataset.cvBound) return;
      btn.dataset.cvBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.hasAttribute('disabled')) return;
        var variantId = btn.getAttribute('data-cv-variant-id');
        if (!variantId) return;
        btn.classList.add('cv-added');
        setTimeout(function () { btn.classList.remove('cv-added'); }, 320);
        var original = btn.textContent;
        btn.setAttribute('disabled', 'disabled');
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'checkout';
          })
          .catch(function () {
            btn.removeAttribute('disabled');
            btn.textContent = original;
          });
      });
    });
  }

  /* ---------- Video play overlays ---------- */
  function initVideo(root) {
    (root || document).querySelectorAll('.cv-vmedia[data-cv-video]').forEach(function (wrap) {
      var btn = wrap.querySelector('.cv-play-btn');
      if (!btn || btn.dataset.cvBound) return;
      btn.dataset.cvBound = '1';
      btn.addEventListener('click', function () {
        var hosted = wrap.querySelector('video');
        if (hosted) {
          hosted.play();
          wrap.classList.add('cv-playing');
          btn.style.display = 'none';
          var tag = wrap.querySelector('.cv-video-tag');
          if (tag) tag.style.display = 'none';
          return;
        }
        var embed = wrap.getAttribute('data-cv-embed');
        if (embed) {
          var iframe = document.createElement('iframe');
          iframe.setAttribute('src', embed);
          iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen');
          iframe.setAttribute('allowfullscreen', 'true');
          iframe.setAttribute('frameborder', '0');
          wrap.innerHTML = '';
          wrap.appendChild(iframe);
        }
      });
    });
  }

  /* ---------- Sticky mobile bar ---------- */
  function initStickyBar() {
    var bar = document.querySelector('.cv-sticky-bar');
    var heroCTA = document.querySelector('[data-cv-hero-cta]');
    if (!bar || !heroCTA || bar.dataset.cvBound) return;
    bar.dataset.cvBound = '1';
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          var e = entries[0];
          bar.classList.toggle('cv-show', !e.isIntersecting && e.boundingClientRect.top < 0);
        },
        { threshold: 0 }
      ).observe(heroCTA);
    }
  }

  function initAll(root) {
    initAccordions(root);
    initGallery(root);
    initVariants(root);
    initBuyNow(root);
    initVideo(root);
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Re-init when a section is re-rendered in the theme editor */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  /* Recalculate open accordion heights on resize */
  window.addEventListener('resize', function () {
    document.querySelectorAll('.cv-acc-item.cv-open .cv-acc-body').forEach(function (b) {
      b.style.maxHeight = b.scrollHeight + 24 + 'px';
    });
  });
})();
